import { render, staticRenderFns } from "./selfSourcingPublicity.vue?vue&type=template&id=5e2b0923"
import script from "./selfSourcingPublicity.vue?vue&type=script&lang=js"
export * from "./selfSourcingPublicity.vue?vue&type=script&lang=js"
import style0 from "./selfSourcingPublicity.vue?vue&type=style&index=0&id=5e2b0923&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports